/**
 * Image lightbox for [avinc_image_lightbox] shortcode.
 *
 * Uses document-level delegation (no Alpine attrs) so markup still works
 * after wp_kses_post in WYSIWYG templates.
 *
 * @requires ../node_modules/basiclightbox/dist/basicLightbox.min.js
 */

'use strict';

;( () => {
	let activeLightbox = null;

	const openImageLightbox = ( trigger ) => {
		if ( ! trigger || activeLightbox ) return;

		const url    = trigger.getAttribute( 'data-image-url' );
		const alt    = trigger.getAttribute( 'data-image-alt' ) || '';
		const srcset = trigger.getAttribute( 'data-image-srcset' ) || '';

		if ( ! url ) return;

		if ( ! window.basicLightbox || 'function' !== typeof window.basicLightbox.create ) {
			console.error( 'basicLightbox is unavailable.' );
			return;
		}

		const wrapperEl = document.createElement( 'div' );
		const closeBtn  = document.createElement( 'button' );
		const imageEl   = document.createElement( 'img' );

		closeBtn.type      = 'button';
		closeBtn.className = 'close icon icon--close icon--white';
		closeBtn.setAttribute( 'aria-label', 'Close image' );
		closeBtn.innerHTML = '<span class="sr-only">Close image</span>';

		imageEl.src       = url;
		imageEl.alt       = alt;
		imageEl.className = 'image-lightbox-img';
		imageEl.setAttribute( 'loading', 'eager' );
		imageEl.setAttribute( 'decoding', 'async' );

		if ( srcset ) {
			imageEl.srcset = srcset;
			imageEl.sizes  = '(max-width: 1320px) 100vw, 1320px';
		}

		wrapperEl.appendChild( closeBtn );
		wrapperEl.appendChild( imageEl );

		const onKeyDown = ( e ) => {
			if ( 'Escape' === e.key && activeLightbox ) activeLightbox.close();
		};

		const instance = window.basicLightbox.create( wrapperEl, {
			onShow: () => {
				document.addEventListener( 'keydown', onKeyDown );
			},
			onClose: () => {
				document.removeEventListener( 'keydown', onKeyDown );
				activeLightbox = null;
				return true;
			},
		} );

		if ( ! instance ) {
			console.error( 'Unable to create lightbox instance.' );
			return;
		}

		closeBtn.addEventListener( 'click', () => instance.close() );

		activeLightbox = instance;
		instance.show();
	};

	document.addEventListener( 'click', ( event ) => {
		const trigger = event.target.closest( '[data-image-lightbox]' );

		if ( ! trigger ) return;

		event.preventDefault();
		openImageLightbox( trigger );
	} );
})();
